import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

//上传获取sheet页信息
export function getSheetName(obj) {
  return request({
    url: urlPrefix+'/wagebatchinfo/stepZero',
    method: 'post',
    data: obj
  })
}
//导入第一步
export function uploadStepOne(obj) {
  return request({
    url: urlPrefix+'/wagebatchinfo/stepOne',
    method: 'post',
    data: obj
  })
}

//获取客户信息
export function getCurrentCustomerInfos(){
  return request({
    url: urlPrefix+ '/wagebatchinfo/customerInfo',
    method: 'post',
  })
}

//获取所有的工资模板
export function getArllTemplateInfos(){
  return request({
    url: urlPrefix+'/salaryTemplate/templateInfoList',
    method: 'post'
  })
}

//根据薪酬组id获取薪资模板
export function getTemplateInfoListByGroupId(obj){
  return request({
    url: urlPrefix+'/salaryTemplate/templateInfoListByGroupId/'+obj,
    method: 'get',
    params:obj
  })
}


// 上传第二步 字段匹配
export function uploadStepTwo(obj){
  return request({
    url: urlPrefix+'/wagebatchinfo/stepTwo',
    method: 'post',
    data: obj
  })
}

// 上传第三步 确认的数据插入正式表中
export function uploadStepThree(obj){
  return request({
    url: urlPrefix+'/wagebatchinfo/stepThree',
    method: 'post',
    data: obj
  })
}


//保存薪资明细数据
export function saveItemData(obj){
  return request({
    url: urlPrefix + '/wagebatchdetail/saveItemData',
    method: 'post',
    data: obj
  })
}

//删除薪资明细数据
export function deleteItemData(obj){
  return request({
    url: urlPrefix + '/wagebatchdetail/deleteItemData',
    method: 'post',
    data: obj
  })
}

export function getItemColumnData(obj) {
  return request({
    url: urlPrefix + '/wagebatchdetail/getItemColumnData',
    method: 'post',
    data: obj
  })
}
export function getItemDataList(obj) {
  return request({
    url: urlPrefix + '/wagebatchdetail/getItemDataList',
    method: 'post',
    data:obj
  })
}
export function getSelectData(obj) {
  return request({
    url: urlPrefix + '/wagebatchdetail/getSelectData',
    method: 'post',
    data:obj
  })
}
export function getItemDatas(obj) {
  return request({
    url: urlPrefix + '/wagebatchdetail/getItemDatas',
    method: 'post',
    data:obj
  })
}


//雇员下载精简模板
export function downloadBankPayFile(obj) {
  return request({
    url: urlPrefix +'/bankpay-file/download-payfile',
    method: 'get',
    responseType: 'arraybuffer',
    params: obj,
  });
}

//单工资条查询
export function findPageByParams(obj) {
  return request({
    url: urlPrefix + '/wagebatchinfo/page2',
    method: 'post',
    data: obj,
  });
}

//批次导入确认提交调用接口
export function confirm(obj) {
  // debugger;
  return request({
    url: urlPrefix + '/wagebatchinfo/confirm',
    method: 'post',
    data: obj,
  });
}

//查询
export function queryBatchDetailPage(obj) {
  return request({
    url: urlPrefix + '/wagebatchdetail/listpage-bymap',
    method: 'get',
    params: obj,
  });
}

//单工资条删除
export function deleteAction(obj) {
  return request({
    url: urlPrefix + '/wagebatchinfo/delete-and-item/'+obj,
    method: 'delete',
    data: obj,
  });

}

//薪资下载精简模板
export function downloadBatchDetailExcelTmpl(obj) {
  return request({
    url: urlPrefix +'/excel/downloadtmpexcel/batchDetail',
    // method: 'get',
    responseType: 'arraybuffer',
    params: obj,
  });
}

// 计算薪资明细数据
export function calculateSalaryDetail(data){
  return request({
    url: urlPrefix+'/wageCompute/calculate',
    method: 'post',
    data: data
  })
}

// 获取未完成的批次
export function getUnfinishBatchInfo(data){
  return request({
    url: urlPrefix+'/wagebatchinfo/get-is-payfinish',
    method: 'post',
    data: data
  })
}

// 获取未完成的批次
export function getBatchInfoByGroupId(data){
  return request({
    url: urlPrefix+'/wagebatchinfo/get-batchinfo-bygroupid',
    method: 'post',
    data: data
  })
}


// 导出excel错误文件信息
export function exportTable(data){
  return request({
    url: urlPrefix +'/wagebatchinfo/exportExcleAll',
    method: 'POST',
    data: data,
    responseType: 'arraybuffer',
  });
}

//数据导入明细新增发方法
export function addSaveItemData(data){
  return request({
    url: urlPrefix + '/wagebatchdetail/addSaveItemData',
    method: 'POST',
    data: data,
  });
}

//数据导入明细重新拉取方法
export function reloadUpdateAll(data){
  return request({
    url: urlPrefix + '/wagebatchdetail/reloadUpdateAll',
    method: 'POST',
    data: data,
  });
}

//校验批次名
export function checkBatchName(data){
  return request({
    url: urlPrefix + '/wagebatchinfo/checkBatchName',
    method: 'POST',
    params: data,
  });
}

//查询仅工资条明细发放
export function queryBatchOnlyPayDetailPage(obj) {
  return request({
    url: urlPrefix + '/wagebatchdetail/listonlypaypage-bymap',
    method: 'get',
    params: obj,
  });
}
